'use strict';

angular.module('myConsultApp')
    .service('GoogleServices', function ($resource, ENV, Session, deviceDetector, LOCATION_API, uiGmapGoogleMapApi) {
      var self = this;
      var successCoordCallback;
      var isLatLng = false;
      var acceptedTypes = ['colloquial_area','locality','neighborhood',
        'political','postal_town','street_address','sublocality', 'postal_code', 'premise']


      // Get user location co-ordinates according to user's device
      self.getCordinates = function (zipCode, sCallBack) {
          successCoordCallback = sCallBack;
          if(zipCode){
            self.getCordinateZipUserInput(zipCode);
          }
          else if (deviceDetector.isDesktop()){
             self.getCordinateIP();
          }
          else{
            self.getCordinateGeolocation();
          };
        };


      // Callback functions for Geo Location search
      self.onLocationSuccess = function(position) {
         var coordinates = String(position.coords.latitude)+ ',' + String(position.coords.longitude);
         var isLatLng = true;
         self.getCordinateZipUserInput(coordinates, isLatLng);
        };

      self.onLocationError = function(error) {
          self.getCordinateIP();
      };


      //Method to get the user location co-ordinates using geo location
      self.getCordinateGeolocation = function() {
            navigator.geolocation.getCurrentPosition(self.onLocationSuccess, self.onLocationError, { timeout: 12000 });
        };


      //Method to get the user location co-ordinates using the IP
      self.getCordinateIP = function () {
            var locationDetails = $resource(LOCATION_API.ipLocation,{},{get : {withCredentials: false} });
            return locationDetails.get().$promise.then(function(response) {
                var coordinates = {
                                    latitude : response.latitude,
                                    longitude: response.longitude,
                                    city: response.city,
                                    state: response.region
                                    }
                successCoordCallback(coordinates);
            });
        };
        
      //Method to get the user location for provided zipcode or any input
      self.getCordinateZipUserInput = function (zipAdd, isLatLng) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode( { "address": zipAdd }, function(results, status) {
              if (status == google.maps.GeocoderStatus.OK && results.length > 0) {
                  var result = results[0];
                  if(self.arrIntersection(result.types).length > 0) {
                    var state = '';
                    var city = '';

                    for (var i=0; i<result.address_components.length; i++){
                        if (result.address_components[i].types.indexOf("administrative_area_level_1") != -1){
                          state = result.address_components[i].short_name;
                        }
                        if (result.address_components[i].types.indexOf("locality") != -1){
                          city = result.address_components[i].long_name;
                        }
                    }

                    var coordinates = {
                      latitude: result.geometry.location.lat(),
                      longitude: result.geometry.location.lng(),
                      city: '',
                      state: state
                    };

                    if (result && !isLatLng) {
                      coordinates.city = zipAdd;
                    } else if (result && isLatLng) {
                      coordinates.city = city;
                    }

                    successCoordCallback(coordinates);

                  } else {
                    successCoordCallback({ latitude : null, longitude: null, city: null, state: null});
                  }

              }else{
                successCoordCallback({ latitude : null, longitude: null, city: null, state: null});
              }
          });
        };

        self.arrIntersection = function(arr){
            var commonValues = arr.filter(function(value) {
                return acceptedTypes.indexOf(value) > -1;
            });
           return  commonValues
        }

        self.prepareMapMarker = function(value){
          var preparedMarker = null;
          preparedMarker = {
            id: value.id,
            latitude: value.latitude,
            longitude: value.longitude,
            showWindow: false,
            show: true,
            icon:{
	            path: "M28.461,14.72c0-7.434-6.028-13.46-13.461-13.46c-7.435,0-13.46,6.027-13.46,13.46c0,7.146,4.973,11.208,8.331,13.656L15,39.299l5.132-10.926C23.489,25.927,28.461,21.953,28.461,14.72z",
	            fillColor: '#ff6400',
	            anchor: new google.maps.Point(15,40),
	            fillOpacity: 1,
	            strokeWeight: 1,
	            strokeColor: "#666",
	            scale: 1
	        	},
            options:{
              "labelContent":value.count.toString(),
              "labelAnchor":"20 35",
              "labelStyle": {width: "40px", color: "white", padding: "1px 4px", whiteSpace: "nowrap", textAlign: "center", fontWeight: "regular", fontSize: "14px"},
              "labelClass":"marker-labels"
            },
            click: function(e) {
              var marker = e;
              var map = e.map;
              map.panTo(marker.getPosition());
              map.setZoom(10);
            },
          };
          return preparedMarker
        }

  });
